var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDogeBoxMobBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 165,
    viewBox: "0 0 234 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6699 14.2498L19.6699 44.4998V107L49.6699 76.7498V14.2498Z",
    fill: "#F9F0DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9079 13.6719C50.1421 13.7683 50.2949 13.9965 50.2949 14.2498V76.7498C50.2949 76.9146 50.2298 77.0728 50.1137 77.1899L20.1137 107.44C19.9354 107.62 19.6661 107.674 19.4319 107.578C19.1978 107.481 19.0449 107.253 19.0449 107V44.4998C19.0449 44.3349 19.1101 44.1767 19.2262 44.0597L49.2261 13.8097C49.4045 13.6298 49.6737 13.5754 49.9079 13.6719ZM20.2949 44.7571V105.482L49.0449 76.4924V15.7676L20.2949 44.7571Z",
    fill: "#020202"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.68 14.2498H49.6699V76.7498H218.68V14.2498Z",
    fill: "#F9F0DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0449 14.2498C49.0449 13.9046 49.3247 13.6248 49.6699 13.6248H218.68C219.025 13.6248 219.305 13.9046 219.305 14.2498V76.7498C219.305 77.0949 219.025 77.3748 218.68 77.3748H49.6699C49.3247 77.3748 49.0449 77.0949 49.0449 76.7498V14.2498ZM50.2949 14.8748V76.1248H218.055V14.8748H50.2949Z",
    fill: "#020202"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M48.8899 14.2498L18.8899 44.4998V107L48.8899 76.7498H217.91V14.2498H48.8899Z",
    fill: "#020202"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1101 22.8361C50.3551 23.0792 50.3567 23.4749 50.1136 23.72L20.1136 53.96C19.8705 54.205 19.4748 54.2066 19.2297 53.9635C18.9847 53.7204 18.9831 53.3247 19.2262 53.0796L49.2262 22.8396C49.4693 22.5946 49.865 22.593 50.1101 22.8361Z",
    fill: "#020202"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.11 32.036C50.3551 32.279 50.3568 32.6748 50.1137 32.9198L20.1137 63.1698C19.8706 63.4149 19.4749 63.4166 19.2298 63.1735C18.9847 62.9304 18.9831 62.5347 19.2262 62.2896L49.2261 32.0396C49.4692 31.7945 49.8649 31.7929 50.11 32.036Z",
    fill: "#020202"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.11 42.556C50.3551 42.799 50.3568 43.1948 50.1137 43.4399L20.1137 73.6899C19.8706 73.935 19.4749 73.9366 19.2298 73.6935C18.9847 73.4505 18.9831 73.0547 19.2262 72.8097L49.2261 42.5597C49.4692 42.3146 49.8649 42.3129 50.11 42.556Z",
    fill: "#020202"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.11 51.7659C50.3551 52.009 50.3568 52.4047 50.1137 52.6498L20.1137 82.8998C19.8706 83.1449 19.4749 83.1466 19.2298 82.9035C18.9847 82.6604 18.9831 82.2647 19.2262 82.0196L49.2261 51.7696C49.4692 51.5245 49.8649 51.5229 50.11 51.7659Z",
    fill: "#020202"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.11 61.4759C50.3551 61.719 50.3568 62.1147 50.1137 62.3598L20.1137 92.6098C19.8706 92.8549 19.4749 92.8565 19.2298 92.6134C18.9847 92.3704 18.9831 91.9747 19.2262 91.7296L49.2261 61.4796C49.4692 61.2345 49.8649 61.2328 50.11 61.4759Z",
    fill: "#020202"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogeBoxMobBack);
export default __webpack_public_path__ + "static/media/doge-box-mob-back.5d9cc81b50034ec4aebd2524ca22b6b3.svg";
export { ForwardRef as ReactComponent };